package com.milta

import kotlin.Boolean
import kotlin.String

internal actual object BuildKonfig {
  public actual val BASE_URL: String = "https://api.acceptance.milta.pro"

  public actual val DEV_HOST: String = ""

  public actual val IS_DEV: Boolean = false

  public actual val GOOGLE_WEB_CLIENT_ID: String =
      "291618980289-0rbulre54f3dk7k6fljb6roevp82224v.apps.googleusercontent.com"

  public actual val APPLE_SERVICE_ID: String = ""

  public actual val APPLE_REDIRECT_URI: String = ""

  public actual val APPLE_REDIRECT_SCHEME: String = "miltaapp"

  public actual val GOOGLE_REDIRECT_URI: String = ""

  public actual val GLITCHTIP_DSN: String = ""

  public actual val GLITCHTIP_ENVIRONMENT: String = "development"
}
